import { Badge } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';

export function CompletionBadge({ isCompleted }: { isCompleted: boolean }) {
  if (isCompleted) {
    return (
      <Badge
        variant="subtle"
        size="sm"
        fontSize="2xs"
        borderRadius="full"
        colorScheme="green"
        ml={2}
        textTransform="capitalize"
      >
        <Trans>Completed</Trans>
      </Badge>
    );
  }

  return (
    <Badge
      variant="subtle"
      size="sm"
      fontSize="2xs"
      borderRadius="full"
      colorScheme="orange"
      ml={2}
      textTransform="capitalize"
    >
      <Trans>In progress</Trans>
    </Badge>
  );
}
